import { Package } from "lucide-react";
import { useTranslation } from "react-i18next";
import { formatPercent } from "~/utils/formatting";
import type { SummaryCardsData } from "~/pages/product-details/tabs/sales-data-tab/data/build-summary-cards-model";
import { MetricColumn } from "./metric-column";
import { SummaryCard } from "./summary-card";

export const TotalUnitsCard = ({
  units,
  amazonSharePercent,
  isLoading,
  unavailableReason,
  onClick,
}: {
  units?: SummaryCardsData["units"];
  /** Ratio of Amazon units to market-panel units (0–1); null when unavailable. */
  amazonSharePercent?: number | null;
  isLoading?: boolean;
  unavailableReason?: string;
  onClick: () => void;
}) => {
  const { t } = useTranslation(["productDetails"]);

  const detail = !unavailableReason
    ? {
        summary: t("salesData.summaryCards.amazonShare"),
        value:
          amazonSharePercent != null ? formatPercent(amazonSharePercent) : "—",
      }
    : undefined;

  return (
    <SummaryCard
      testId="summary-card-units"
      icon={<Package className="h-4 w-4" aria-hidden />}
      title={t("salesData.summaryCards.units.title")}
      isLoading={isLoading}
      badge={t("salesData.summaryCards.byMarket")}
      body={
        <div className="flex divide-x divide-border">
          {(units?.perMarket ?? []).map((entry) => (
            <MetricColumn
              key={entry.market}
              colorClassName={entry.colorClassName}
              description={entry.market}
              available={!entry.isUnavailable}
              value={entry.formattedValue}
            />
          ))}
        </div>
      }
      series={(units?.perMarket ?? []).map((entry) => ({
        key: entry.market,
        color: entry.color,
        points: entry.sparkline,
      }))}
      unavailableReason={unavailableReason}
      detailSummary={detail?.summary}
      detailValue={detail?.value}
      jumpHint={t("salesData.summaryCards.jumpToChart")}
      onClick={onClick}
    />
  );
};
